<sim-base-chip-input
	[formState]="vopSetFc"
	[label]="label"
	[placeholder]="placeholder"
	[isMultiSelect]="canSelectMultipleVopSets"
	[autoCompleteValues]="autoCompleteData"
	[debounceConfig]="{time: 200}"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
